var map = {
	"./1/medal1.png": "Wq54",
	"./2/medal1.png": "Mo0Q",
	"./3/medal1.png": "1Gzo",
	"./4/medal1.png": "lqu9",
	"./5/medal1.png": "8d2L",
	"./6/medal1.png": "kiXT",
	"./7/medal1.png": "ZqS/",
	"./8/medal1.png": "ICuM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YwJi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/medal1\.png$
// module id = YwJi
// module chunks = 1